import { render, staticRenderFns } from "./AudienceIcon.vue?vue&type=template&id=0be0b6b2"
import script from "./AudienceIcon.vue?vue&type=script&lang=js"
export * from "./AudienceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports